import React, { useState } from 'react';
import { Monitor, Smartphone, Globe, Check, DollarSign, CreditCard, Eye, Edit3, X, Search, Server, Megaphone, PenTool, Shield } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const templates = [{
  id: 1,
  name: 'Agenttoboss (Enterprise SaaS)',
  desc: 'Salesforce-inspired CRM Command Center.',
  image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=800',
  theme: {
    primary: 'bg-[#00A1E0]',
    text: 'text-[#00A1E0]',
    light: 'bg-[#F3F6F9]',
    border: 'border-[#D8E2EF]'
  },
  isSpecial: true,
  tab: 'agenttoboss'
}, {
  id: 2,
  name: 'Simons Acquah Agency (InsurTech)',
  desc: 'Elite Fintech-Boutique Insurance Platform.',
  image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&q=80&w=800',
  theme: {
    primary: 'bg-[#002366]',
    text: 'text-[#002366]',
    light: 'bg-slate-50',
    border: 'border-slate-200'
  },
  isSpecial: true,
  tab: 'simons-acquah'
}, {
  id: 3,
  name: 'Growth Engine',
  desc: 'Lead-gen focused landing page.',
  image: 'https://images.unsplash.com/photo-1551288049-bbbda5366392?auto=format&fit=crop&q=80&w=800',
  theme: {
    primary: 'bg-emerald-600',
    text: 'text-emerald-600',
    light: 'bg-emerald-50',
    border: 'border-emerald-100'
  }
}, {
  id: 4,
  name: 'Modern Retail',
  desc: 'Digital product storefront.',
  image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&q=80&w=800',
  theme: {
    primary: 'bg-rose-600',
    text: 'text-rose-600',
    light: 'bg-rose-50',
    border: 'border-rose-100'
  }
}];
export function Storefront() {
  const [currency, setCurrency] = useState('USD');
  const [activeTemplate, setActiveTemplate] = useState(1);
  const [previewTemplate, setPreviewTemplate] = useState<number | null>(null);
  const getCurrencySymbol = () => {
    switch (currency) {
      case 'CAD':
        return 'C$';
      default:
        return '$';
    }
  };
  const activeTheme = previewTemplate ? templates.find(t => t.id === previewTemplate)?.theme : null;
  const sym = getCurrencySymbol();
  return <div className="space-y-8 max-w-[1600px] mx-auto" data-id="element-1984">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-1985">
        <div data-id="element-1986">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-1987">
            Storefront & Landing Pages
          </h1>
          <p className="text-sm text-gray-500 font-medium" data-id="element-1988">
            Manage your conversion-optimized customer entry points.
          </p>
        </div>
        <div className="flex items-center gap-4" data-id="element-1989">
          <div className="flex bg-gray-50 p-1 rounded-lg border border-gray-200" data-id="element-1990">
            {['USD', 'CAD'].map(c => <button key={c} onClick={() => setCurrency(c)} className={`px-4 py-1.5 text-xs font-bold rounded-md transition-all ${currency === c ? 'bg-white text-indigo-600 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-1991">
                {c}
              </button>)}
          </div>
          <button className="px-6 py-2.5 bg-indigo-600 text-white rounded-lg text-sm font-bold hover:bg-indigo-700 shadow-lg shadow-indigo-500/20 transition-all flex items-center gap-2" data-id="element-1992">
            <Globe size={18} data-id="element-1993" />
            Go Live
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1994">
        {templates.map(t => <motion.div key={t.id} whileHover={{
        y: -4
      }} className={`bg-white rounded-lg border-2 overflow-hidden group transition-all ${activeTemplate === t.id ? 'border-indigo-600 shadow-md' : 'border-gray-100 shadow-sm hover:border-gray-200'}`} data-id="element-1995">
            <div className="aspect-video relative overflow-hidden bg-gray-100" data-id="element-1996">
              <img src={t.image} alt={t.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-1997" />
              <div className="absolute inset-0 bg-slate-900/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2 px-4" data-id="element-1998">
                <button onClick={() => {
              if ((t as any).isSpecial) {
                window.dispatchEvent(new CustomEvent('changeTab', {
                  detail: (t as any).tab
                }));
              } else {
                setPreviewTemplate(t.id);
              }
            }} className="flex-1 py-2 bg-white text-slate-900 rounded-lg text-[10px] font-bold shadow-lg hover:bg-gray-50 transition-all flex items-center justify-center gap-1.5" data-id="element-1999">
                  <Eye size={12} data-id="element-2000" />{' '}
                  {(t as any).isSpecial ? 'Open Site' : 'Preview'}
                </button>
                <button onClick={() => setActiveTemplate(t.id)} className="flex-1 py-2 bg-indigo-600 text-white rounded-lg text-[10px] font-bold shadow-lg hover:bg-indigo-700 transition-all flex items-center justify-center gap-1.5" data-id="element-2001">
                  <Edit3 size={12} data-id="element-2002" /> Customize
                </button>
              </div>
              {activeTemplate === t.id && <div className="absolute top-3 right-3 bg-indigo-600 text-white px-2 py-1 rounded-full text-[10px] font-bold flex items-center gap-1 shadow-lg" data-id="element-2003">
                  <Check size={10} data-id="element-2004" /> Active
                </div>}
            </div>
            <div className="p-4" data-id="element-2005">
              <div className="flex items-center justify-between mb-1" data-id="element-2006">
                <p className="text-sm font-bold text-slate-900" data-id="element-2007">{t.name}</p>
                <div className="flex gap-1" data-id="element-2008">
                  <Monitor size={12} className="text-gray-400" data-id="element-2009" />
                  <Smartphone size={12} className="text-gray-400" data-id="element-2010" />
                </div>
              </div>
              <p className="text-xs text-gray-500 font-medium line-clamp-1" data-id="element-2011">
                {t.desc}
              </p>
            </div>
          </motion.div>)}
      </div>

      <div className="bg-slate-900 rounded-lg p-8 text-white relative overflow-hidden" data-id="element-2012">
        <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-2013">
          <div className="max-w-xl" data-id="element-2014">
            <h2 className="text-2xl font-bold mb-2" data-id="element-2015">Multi-Currency Engine</h2>
            <p className="text-slate-400 text-sm leading-relaxed" data-id="element-2016">
              Your storefront automatically detects customer location and
              displays pricing in {currency}. All payouts will be converted to
              your base currency at the mid-market rate.
            </p>
          </div>
          <div className="flex gap-4" data-id="element-2017">
            <div className="bg-slate-800 p-4 rounded-lg border border-slate-700 flex items-center gap-4" data-id="element-2018">
              <div className="w-10 h-10 bg-green-500/20 rounded-lg flex items-center justify-center text-green-500" data-id="element-2019">
                <DollarSign size={20} data-id="element-2020" />
              </div>
              <div data-id="element-2021">
                <p className="text-[10px] font-bold text-slate-500 uppercase" data-id="element-2022">
                  Current Rate
                </p>
                <p className="text-lg font-bold" data-id="element-2023">1 USD = 1.35 CAD</p>
              </div>
            </div>
            <div className="bg-slate-800 p-4 rounded-lg border border-slate-700 flex items-center gap-4" data-id="element-2024">
              <div className="w-10 h-10 bg-blue-500/20 rounded-lg flex items-center justify-center text-blue-500" data-id="element-2025">
                <CreditCard size={20} data-id="element-2026" />
              </div>
              <div data-id="element-2027">
                <p className="text-[10px] font-bold text-slate-500 uppercase" data-id="element-2028">
                  Settlement
                </p>
                <p className="text-lg font-bold" data-id="element-2029">T+2 Days</p>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute top-0 right-0 w-64 h-64 bg-blue-600/10 blur-[100px] -mr-32 -mt-32" data-id="element-2030"></div>
      </div>

      {/* Full Screen Preview Modal */}
      <AnimatePresence data-id="element-2031">
        {previewTemplate && activeTheme && <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/80 backdrop-blur-sm p-4 md:p-8" data-id="element-2032">
            <motion.div initial={{
          opacity: 0,
          y: 50,
          scale: 0.95
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.95
        }} transition={{
          duration: 0.3
        }} className="w-full h-full max-w-7xl bg-white rounded-xl shadow-2xl overflow-hidden flex flex-col relative" data-id="element-2033">
              {/* Modal Controls */}
              <div className="absolute top-4 right-4 z-50 flex gap-3" data-id="element-2034">
                <button onClick={() => {
              setActiveTemplate(previewTemplate);
              setPreviewTemplate(null);
            }} className={`px-4 py-2 ${activeTheme.primary} text-white rounded-lg text-sm font-bold shadow-lg flex items-center gap-2`} data-id="element-2035">
                  <Check size={16} data-id="element-2036" /> Activate This Template
                </button>
                <button onClick={() => setPreviewTemplate(null)} className="w-10 h-10 bg-white text-slate-900 rounded-lg shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors" data-id="element-2037">
                  <X size={20} data-id="element-2038" />
                </button>
              </div>

              {/* MOCK STOREFRONT CONTENT */}
              <div className="flex-1 overflow-y-auto bg-gray-50" data-id="element-2039">
                {/* Nav */}
                <nav className="bg-white border-b border-gray-100 px-8 py-4 flex items-center justify-between sticky top-0 z-40" data-id="element-2040">
                  <div className="flex items-center gap-2" data-id="element-2041">
                    <div className={`w-8 h-8 rounded ${activeTheme.primary} flex items-center justify-center text-white font-bold`} data-id="element-2042">
                      M
                    </div>
                    <span className="font-bold text-lg text-slate-900" data-id="element-2043">
                      MyReseller
                    </span>
                  </div>
                  <div className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-600" data-id="element-2044">
                    <a href="#" className={`hover:${activeTheme.text}`} data-id="element-2045">
                      Hosting
                    </a>
                    <a href="#" className={`hover:${activeTheme.text}`} data-id="element-2046">
                      Domains
                    </a>
                    <a href="#" className={`hover:${activeTheme.text}`} data-id="element-2047">
                      Services
                    </a>
                    <a href="#" className={`hover:${activeTheme.text}`} data-id="element-2048">
                      Support
                    </a>
                  </div>
                  <div className="flex items-center gap-4" data-id="element-2049">
                    <span className="text-sm font-bold text-slate-900" data-id="element-2050">
                      Login
                    </span>
                    <button className={`px-5 py-2 ${activeTheme.primary} text-white rounded-lg text-sm font-bold`} data-id="element-2051">
                      Get Started
                    </button>
                  </div>
                </nav>

                {/* Hero / Domain Search */}
                <div className={`${activeTheme.light} px-8 py-24 text-center border-b ${activeTheme.border}`} data-id="element-2052">
                  <h1 className="text-4xl md:text-6xl font-bold text-slate-900 mb-6 tracking-tight" data-id="element-2053">
                    Find Your Perfect Domain
                  </h1>
                  <p className="text-lg text-gray-600 mb-10 max-w-2xl mx-auto" data-id="element-2054">
                    Secure your online identity with our premium hosting and
                    domain registration services. Built for speed, security, and
                    scale.
                  </p>

                  <div className="max-w-3xl mx-auto bg-white p-2 rounded-xl shadow-lg flex items-center" data-id="element-2055">
                    <Search className="text-gray-400 ml-4" size={24} data-id="element-2056" />
                    <input type="text" placeholder="Enter your ideal domain name..." className="flex-1 px-4 py-4 text-lg focus:outline-none" data-id="element-2057" />
                    <button className={`px-8 py-4 ${activeTheme.primary} text-white rounded-lg font-bold text-lg whitespace-nowrap`} data-id="element-2058">
                      Search
                    </button>
                  </div>
                  <div className="mt-6 flex items-center justify-center gap-6 text-sm font-bold text-gray-500" data-id="element-2059">
                    <span data-id="element-2060">.com {sym}15.00</span>
                    <span data-id="element-2061">.ca {sym}12.00</span>
                    <span data-id="element-2062">.net {sym}14.00</span>
                  </div>
                </div>

                {/* Products Showcase */}
                <div className="px-8 py-20 max-w-7xl mx-auto" data-id="element-2063">
                  <div className="text-center mb-16" data-id="element-2064">
                    <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-2065">
                      Powerful Hosting Packages
                    </h2>
                    <p className="text-gray-500" data-id="element-2066">
                      Everything you need to get your business online.
                    </p>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24" data-id="element-2067">
                    {[{
                  name: 'Basic',
                  price: '35',
                  desc: 'Perfect for small sites.'
                }, {
                  name: 'Professional',
                  price: '65',
                  desc: 'For growing businesses.',
                  popular: true
                }, {
                  name: 'Enterprise',
                  price: '99',
                  desc: 'High performance needs.'
                }].map((plan, i) => <div key={i} className={`bg-white rounded-2xl p-8 border ${plan.popular ? `border-2 ${activeTheme.border} shadow-xl relative` : 'border-gray-200 shadow-sm'}`} data-id="element-2068">
                        {plan.popular && <div className={`absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 px-4 py-1 ${activeTheme.primary} text-white text-[10px] font-bold uppercase tracking-widest rounded-full`} data-id="element-2069">
                            Most Popular
                          </div>}
                        <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-2070">
                          {plan.name}
                        </h3>
                        <p className="text-sm text-gray-500 mb-6" data-id="element-2071">
                          {plan.desc}
                        </p>
                        <div className="mb-8" data-id="element-2072">
                          <span className="text-4xl font-bold text-slate-900" data-id="element-2073">
                            {sym}
                            {plan.price}
                          </span>
                          <span className="text-gray-500" data-id="element-2074">/mo</span>
                        </div>
                        <button className={`w-full py-3 rounded-lg font-bold transition-colors ${plan.popular ? `${activeTheme.primary} text-white` : `${activeTheme.light} ${activeTheme.text} hover:bg-gray-100`}`} data-id="element-2075">
                          Select Plan
                        </button>
                      </div>)}
                  </div>

                  <div className="text-center mb-16" data-id="element-2076">
                    <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-2077">
                      Digital Services & Tools
                    </h2>
                    <p className="text-gray-500" data-id="element-2078">
                      Grow your brand with our expert services and AVA Suite.
                    </p>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2079">
                    <div className="bg-white p-8 rounded-2xl border border-gray-200 shadow-sm flex flex-col items-center text-center" data-id="element-2080">
                      <div className={`w-16 h-16 rounded-2xl ${activeTheme.light} ${activeTheme.text} flex items-center justify-center mb-6`} data-id="element-2081">
                        <Megaphone size={32} data-id="element-2082" />
                      </div>
                      <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-2083">
                        Digital Marketing
                      </h3>
                      <p className="text-gray-500 text-sm mb-6" data-id="element-2084">
                        SEO, Social Media, and PPC campaigns to drive traffic.
                      </p>
                      <span className={`mt-auto font-bold ${activeTheme.text}`} data-id="element-2085">
                        From {sym}300/mo
                      </span>
                    </div>
                    <div className="bg-white p-8 rounded-2xl border border-gray-200 shadow-sm flex flex-col items-center text-center" data-id="element-2086">
                      <div className={`w-16 h-16 rounded-2xl ${activeTheme.light} ${activeTheme.text} flex items-center justify-center mb-6`} data-id="element-2087">
                        <PenTool size={32} data-id="element-2088" />
                      </div>
                      <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-2089">
                        Graphic Design
                      </h3>
                      <p className="text-gray-500 text-sm mb-6" data-id="element-2090">
                        Logos, branding, and marketing materials.
                      </p>
                      <span className={`mt-auto font-bold ${activeTheme.text}`} data-id="element-2091">
                        From {sym}250/mo
                      </span>
                    </div>
                    <div className="bg-white p-8 rounded-2xl border border-gray-200 shadow-sm flex flex-col items-center text-center" data-id="element-2092">
                      <div className={`w-16 h-16 rounded-2xl ${activeTheme.light} ${activeTheme.text} flex items-center justify-center mb-6`} data-id="element-2093">
                        <Shield size={32} data-id="element-2094" />
                      </div>
                      <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-2095">
                        AVA Security Suite
                      </h3>
                      <p className="text-gray-500 text-sm mb-6" data-id="element-2096">
                        Advanced monitoring and DDoS protection for your sites.
                      </p>
                      <span className={`mt-auto font-bold ${activeTheme.text}`} data-id="element-2097">
                        From {sym}15/mo
                      </span>
                    </div>
                  </div>
                </div>

                {/* Footer */}
                <footer className="bg-slate-900 text-slate-400 py-12 px-8" data-id="element-2098">
                  <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-2099">
                    <div data-id="element-2100">
                      <div className="flex items-center gap-2 mb-6" data-id="element-2101">
                        <div className={`w-8 h-8 rounded ${activeTheme.primary} flex items-center justify-center text-white font-bold`} data-id="element-2102">
                          M
                        </div>
                        <span className="font-bold text-lg text-white" data-id="element-2103">
                          MyReseller
                        </span>
                      </div>
                      <p className="text-sm" data-id="element-2104">
                        Empowering businesses online since 2023.
                      </p>
                    </div>
                    <div data-id="element-2105">
                      <h4 className="text-white font-bold mb-4" data-id="element-2106">Services</h4>
                      <ul className="space-y-2 text-sm" data-id="element-2107">
                        <li data-id="element-2108">
                          <a href="#" className="hover:text-white" data-id="element-2109">
                            Web Hosting
                          </a>
                        </li>
                        <li data-id="element-2110">
                          <a href="#" className="hover:text-white" data-id="element-2111">
                            Domains
                          </a>
                        </li>
                        <li data-id="element-2112">
                          <a href="#" className="hover:text-white" data-id="element-2113">
                            Marketing
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div data-id="element-2114">
                      <h4 className="text-white font-bold mb-4" data-id="element-2115">Support</h4>
                      <ul className="space-y-2 text-sm" data-id="element-2116">
                        <li data-id="element-2117">
                          <a href="#" className="hover:text-white" data-id="element-2118">
                            Help Center
                          </a>
                        </li>
                        <li data-id="element-2119">
                          <a href="#" className="hover:text-white" data-id="element-2120">
                            Contact Us
                          </a>
                        </li>
                        <li data-id="element-2121">
                          <a href="#" className="hover:text-white" data-id="element-2122">
                            System Status
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div data-id="element-2123">
                      <h4 className="text-white font-bold mb-4" data-id="element-2124">Legal</h4>
                      <ul className="space-y-2 text-sm" data-id="element-2125">
                        <li data-id="element-2126">
                          <a href="#" className="hover:text-white" data-id="element-2127">
                            Privacy Policy
                          </a>
                        </li>
                        <li data-id="element-2128">
                          <a href="#" className="hover:text-white" data-id="element-2129">
                            Terms of Service
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </footer>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </div>;
}